import React from "react";
import {useTranslation} from "react-i18next";
import cn from "classnames";

import {Project} from "../schema";
import ReactLink from "./ReactLink";
import {reverse} from "../routing";
import Skeleton from "../ui/skeleton";

import classes from "./ProjectCard.module.css";
import {gql} from "@apollo/client";

type props = React.ComponentProps<typeof ReactLink> & {
  project: Pick<Project, "id" | "name" | "canPlay" | "hasPassed" | "participationCreatedAt">
}

export default function ProjectCard({className, project, ...props}: props) {
  const {t} = useTranslation();

  return (
    <div className={cn(classes.root, className)}>
      <ReactLink
        title={project.name}
        className={cn(classes.playArea, {[classes.disabled]: !project.canPlay})}
        href={project.canPlay ? reverse("playerProject", {id: project.id}) : undefined}
        {...props}
      >
        <div className={classes.background}>
          <div className={cn(classes.card, classes.cardGradient)}>
          </div>
          <div className={classes.description}>
            <h1 className={classes.name} translate="no">{project.name ? project.name :
              <span className={classes.notSpecified}>{t("common.notSpecified")}</span>}</h1>
          </div>
        </div>
      </ReactLink>
    </div>
  );
}

ProjectCard.Skeleton = React.memo(function ({className}: { className?: string }) {
  return (
    <div className={cn(classes.root, className)}>
      <Skeleton.Block height={120} className={classes.root}/>
    </div>
  )
});

ProjectCard.fragments = {
  root: gql`
    fragment ProjectCard on Project {
      id
      name
      canPlay
      hasPassed
      participationCreatedAt
    }
  `
}
